import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// import { AppState } from '@capacitor/app';
import { failedTransaction, setLoadingSpinner } from '../actions/shared.action';
import { catchError, exhaustMap, filter, map, mergeMap, of, tap } from 'rxjs';
import { ROUTER_NAVIGATION, RouterNavigatedAction } from '@ngrx/router-store';
import * as fromTournamentActions from '../actions/tournament.action'
import { APIResponse } from 'src/app/models/api-response.model';
import { AccountService } from 'src/app/services/account.service';
import { NavigationExtras, Router } from '@angular/router';
import { TournamentService } from 'src/app/services/tournament.service';
import { AppState } from '../app.state';
import { ModalService } from 'src/app/services/modal.service';

@Injectable()
export class TournamentEffects {

  getSeasons$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/admin/home/tournament');
      }),
      exhaustMap((action) =>
        this.tournamentService.getSeasons().pipe(
          map((response) => { 
            console.log('getSeasons$', response);
            return fromTournamentActions.getSeasonsSuccess({ data: response?.details});
          }),
          catchError((response) => {
            return of(failedTransaction({ data: response.error }));
          })
        )
      )
    )
  });

  reloadSeason$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.getSeasons),
      mergeMap(() => {
        return this.tournamentService.getSeasons().pipe(
          map((response: APIResponse) => {           
            console.log('getSeasons$', response);
            return fromTournamentActions.getSeasonsSuccess({ data: response?.details});
          })
        );
      })
    )
  );

  createSeason$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.createSeason),
      exhaustMap((action) =>
        this.tournamentService.createSeason(action.data).pipe(
          map((response) => {
            return fromTournamentActions.createSeasonSuccess({ data: response });
          }),
          catchError((response) => {
            console.error('createSeason$', response);
            return of(fromTournamentActions.createSeasonFailed({ data: response }));
          })
        )
      )
    )
  );

  createSeasonSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.createSeasonSuccess),
        tap(async (action) => {
          this.modalService.hideCreateSeason();
          this.store.dispatch(fromTournamentActions.getSeasons());
          console.log('createSeasonSuccess$', action.data);
        })
      ),
    { dispatch: false }
  );

  createSeasonFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.createSeasonFailed),
        tap(async (action) => {
          console.log('createSeasonFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  getLeagues$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.getLeagues),
      mergeMap((action) => {
        return this.tournamentService.getLeagues(action.data?.seasonId).pipe(
          map((response: APIResponse) => {           
            console.log('getLeagues$', response);
            const data = {
              season: action?.data,
              leagues: response.details
            }
            if(action.redirect){
              this.router.navigateByUrl('/admin/home/season/leagues');
            }
            return fromTournamentActions.getLeaguesSuccess({ data });
          })
        );
      })
    )
  );

  createSeasonLeague$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.createSeasonLeague),
      exhaustMap((action) =>
        this.tournamentService.createSeasonLeague(action.data).pipe(
          map((response) => {
            return fromTournamentActions.createSeasonLeagueSuccess({ data: action.data });
          }),
          catchError((response) => {
            console.error('createSeason$', response);
            return of(fromTournamentActions.createSeasonLeagueFailed({ data: response }));
          })
        )
      )
    )
  );

  createSeasonLeagueSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.createSeasonLeagueSuccess),
        tap(async (action) => {
          this.modalService.hideCreateSeasonLeague();
          this.store.dispatch(fromTournamentActions.getLeagues({data: action?.data, redirect: false}));
          console.log('createSeasonLeagueSuccess$', action.data);
        })
      ),
    { dispatch: false }
  );

  createSeasonLeagueFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.createSeasonLeagueFailed),
        tap(async (action) => {
          console.log('createSeasonLeagueFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  getLeagueDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.getLeagueDetails),
      exhaustMap((action) =>
        this.tournamentService.getLeagueDetails(action.data).pipe(
          map((response) => {
            return fromTournamentActions.getLeagueDetailsSuccess({ data: action.data });
          }),
          catchError((response) => {
            console.error('getLeagueDetails$', response);
            return of(fromTournamentActions.getLeagueDetailsFailed({ data: response }));
          })
        )
      )
    )
  );

  getLeagueDetailsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getLeagueDetailsSuccess),
        tap(async (action) => {
          console.log('getLeagueDetailsSuccess$', action.data);
        })
      ),
    { dispatch: false }
  );

  getLeagueDetailsFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getLeagueDetailsFailed),
        tap(async (action) => {
          console.log('getLeagueDetailsFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  getLeagueGames$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.getLeagueGames),
      exhaustMap((action) =>
        this.tournamentService.getLeagueGames(action.data).pipe(
          map((response) => {
            return fromTournamentActions.getLeagueGamesSuccess({ data: action.data, league: action?.league });
          }),
          catchError((response) => {
            console.error('getLeagueGames$', response);
            return of(fromTournamentActions.getLeagueGamesFailed({ data: response }));
          })
        )
      )
    )
  );

  getLeagueGamesSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getLeagueGamesSuccess),
        tap(async (action) => {
          console.log('getLeagueGamesSuccess$', action.data);
        })
      ),
    { dispatch: false }
  );

  getLeagueGamesFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getLeagueGamesFailed),
        tap(async (action) => {
          console.log('getLeagueGamesFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  getLeaguePlayers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.getLeaguePlayers),
      exhaustMap((action) =>
        this.tournamentService.getLeaguePlayers(action.data).pipe(
          map((response) => {
            return fromTournamentActions.getLeaguePlayersSuccess({ data: response.details, league: action?.league, redirect: true });
          }),
          catchError((response) => {
            console.error('getLeaguePlayers$', response);
            return of(fromTournamentActions.getLeaguePlayersFailed({ data: response }));
          })
        )
      )
    )
  );

  getLeaguePlayersSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getLeaguePlayersSuccess),
        tap(async (action) => {
          if(action.redirect){
            this.router.navigateByUrl('/admin/home/season/leagues/league-players')
          }
          console.log('getLeaguePlayersSuccess$', action);
        })
      ),
    { dispatch: false }
  );

  getLeaguePlayersFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getLeaguePlayersFailed),
        tap(async (action) => {
          console.log('getLeaguePlayersFailed$', action.data);
        })
      ),
    { dispatch: false }
  );
  
  createLeaguePlayers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.createLeaguePlayers),
      exhaustMap((action) =>
        this.accountService.createPlayer(action.data).pipe(
          map((response) => {
            return fromTournamentActions.createLeaguePlayersSuccess({ data: response.details, league: action?.league });
          }),
          catchError((response) => {
            console.error('getLeaguePlayers$', response);
            return of(fromTournamentActions.createLeaguePlayersFailed({ data: response }));
          })
        )
      )
    )
  );

  createLeaguePlayersSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.createLeaguePlayersSuccess),
        tap(async (action) => {
          this.modalService.hideReviewDetails();
          this.modalService.hideCreateLeaguePlayer();
          this.store.dispatch(fromTournamentActions.getLeaguePlayers({data: action.league.leagueId, league: action.league, redirect: false}))
          console.log('createLeaguePlayersSuccess$', action);
        })
      ),
    { dispatch: false }
  );

  createLeaguePlayersFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.createLeaguePlayersFailed),
        tap(async (action) => {
          console.log('createLeaguePlayersFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  // tournament effects

  assignSeeds$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.assignSeeds),
      exhaustMap((action) =>
        this.tournamentService.assignSeeds(action.data).pipe(
          map((response) => {
            console.log('assignSeeds$', response.details);
            return fromTournamentActions.assignSeedsSuccess({ seasonId: action.seasonId });
          }),
          catchError((response) => {
            console.error('assignSeeds$', response);
            return of(fromTournamentActions.assignSeedsFailed({ data: response }));
          })
        )
      )
    )
  );

  assignSeedsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.assignSeedsSuccess),
        tap(async (action) => {
          this.store.dispatch(fromTournamentActions.getLeagues({data: action?.seasonId, redirect: false}));
        })
      ),
    { dispatch: false }
  );

  assignSeedsFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.assignSeedsFailed),
        tap(async (action) => {
          console.log('assignSeedsFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  generateMatchups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.generateMatchups),
      exhaustMap((action) =>
        this.tournamentService.generateMatchups(action.data).pipe(
          map((response) => {
            console.log('generateMatchups$', response.details);
            return fromTournamentActions.generateMatchupsSuccess({ seasonId: action.seasonId });
          }),
          catchError((response) => {
            console.error('generateMatchups$', response);
            return of(fromTournamentActions.generateMatchupsFailed({ data: response }));
          })
        )
      )
    )
  );

  generateMatchupsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.generateMatchupsSuccess),
        tap(async (action) => {
          this.store.dispatch(fromTournamentActions.getLeagues({data: action?.seasonId, redirect: false}));
        })
      ),
    { dispatch: false }
  );

  generateMatchupsFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.generateMatchupsFailed),
        tap(async (action) => {
          console.log('generateMatchupsFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  startLeagueTournament$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.startLeagueTournament),
      exhaustMap((action) =>
        this.tournamentService.startLeagueTournament(action.data).pipe(
          map((response) => {
            console.log('startLeagueTournament$', response.details);
            return fromTournamentActions.startLeagueTournamentSuccess({ seasonId: action.seasonId });
          }),
          catchError((response) => {
            console.error('startLeagueTournament$', response);
            return of(fromTournamentActions.startLeagueTournamentFailed({ data: response }));
          })
        )
      )
    )
  );

  startLeagueTournamentSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.startLeagueTournamentSuccess),
        tap(async (action) => {
          this.store.dispatch(fromTournamentActions.getLeagues({data: action?.seasonId, redirect: false}));
        })
      ),
    { dispatch: false }
  );

  startLeagueTournamentFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.startLeagueTournamentFailed),
        tap(async (action) => {
          console.log('startLeagueTournamentFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  generateNextRound$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.generateNextRound),
      exhaustMap((action) =>
        this.tournamentService.generateNextRound(action.data).pipe(
          map((response) => {
            console.log('generateNextRound$', response.details);
            return fromTournamentActions.generateNextRoundSuccess({ seasonId: action.seasonId });
          }),
          catchError((response) => {
            console.error('generateNextRound$', response);
            return of(fromTournamentActions.generateNextRoundFailed({ data: response }));
          })
        )
      )
    )
  );

  generateNextRoundSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.generateNextRoundSuccess),
        tap(async (action) => {
          this.store.dispatch(fromTournamentActions.getLeagues({data: action?.seasonId, redirect: false}));
        })
      ),
    { dispatch: false }
  );

  generateNextRoundFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.generateNextRoundFailed),
        tap(async (action) => {
          console.log('generateNextRoundFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  completeLeagueTournament$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.completeLeagueTournament),
      exhaustMap((action) =>
        this.tournamentService.completeLeagueTournament(action.data).pipe(
          map((response) => {
            console.log('completeLeagueTournament$', response.details);
            return fromTournamentActions.completeLeagueTournamentSuccess({ seasonId: action.seasonId });
          }),
          catchError((response) => {
            console.error('completeLeagueTournament$', response);
            return of(fromTournamentActions.completeLeagueTournamentFailed({ data: response }));
          })
        )
      )
    )
  );

  completeLeagueTournamentSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.completeLeagueTournamentSuccess),
        tap(async (action) => {
          this.store.dispatch(fromTournamentActions.getLeagues({data: action?.seasonId, redirect: false}));
        })
      ),
    { dispatch: false }
  );

  completeLeagueTournamentFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.completeLeagueTournamentFailed),
        tap(async (action) => {
          console.log('completeLeagueTournamentFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private tournamentService: TournamentService,
    private router: Router,
    private store: Store<AppState>,
    private modalService: ModalService,
    private accountService: AccountService
    // private store: Store<AppState>,
  ) {}

}
